import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const GET_UNPAID_INVOICES_QUERY = gql`
  query getUnpaidInvoicesQuery($input: UnpaidInvoicesInput!) {
    unpaidInvoices(input: $input) {
      id
      state
      total
      createdAt
      businessEntityUuid
      businessEntityName
      lineItems {
        amount
        description
        subscriptionId
      }
    }
  }
`;

export default function useUnpaidInvoices(accountUuid) {
  const { data, loading, error } = useQuery(GET_UNPAID_INVOICES_QUERY, {
    noThrow: true,
    skip: !accountUuid,
    variables: {
      input: { accountUuid },
    },
  });

  useError(error);

  return {
    loading,
    error,
    unpaidInvoices: data?.unpaidInvoices || [],
  };
}
